
const formatCurrency = (amount) => {
    const numAmount = Number(amount) || 0;
    return new Intl.NumberFormat('ar-EG', {
        style: 'currency',
        currency: 'EGP',
    }).format(numAmount);
};

export default formatCurrency;